import script from "./thirdAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./thirdAccount.vue?vue&type=script&setup=true&lang=js"

import "./thirdAccount.vue?vue&type=style&index=0&id=daf9f250&lang=scss&scoped=true"
import "./thirdAccount.vue?vue&type=style&index=1&id=daf9f250&lang=scss"

import exportComponent from "/data/soft/jenkins/workspace/S09_ehm-acsecurity-pro-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daf9f250"]])

export default __exports__